import React from 'react';

function GitRepositoryListPage() {
    return <div>GitRepositoryListPage</div>;
}

export default GitRepositoryListPage;
